var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolunteerActivism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #7f84f6;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.7,12.4l-3.8-3.6c-.4-.4-.8-.9-1.1-1.4-.3-.5-.4-1.1-.4-1.7s.3-1.4.8-1.9c.5-.5,1.1-.8,1.9-.8s1,.1,1.5.4c.4.3.8.7,1.2,1.1.3-.4.7-.8,1.2-1.1.4-.3.9-.4,1.5-.4s1.4.3,1.9.8c.5.5.8,1.1.8,1.9s-.1,1.2-.4,1.7c-.3.5-.7,1-1.1,1.4,0,0-3.8,3.6-3.8,3.6ZM15.7,11l3-2.9c.4-.3.7-.7.9-1.1.3-.4.4-.9.4-1.4s-.2-.8-.5-1.2-.7-.5-1.2-.5-.8.1-1.1.4c-.3.2-.6.5-.9.8l-.7.9-.7-.9c-.3-.3-.5-.6-.9-.8-.3-.2-.7-.4-1.1-.4s-.8.2-1.2.5c-.3.3-.5.7-.5,1.2s.1.9.4,1.4c.3.4.6.8.9,1.1l3,2.9ZM6.4,18.7l7.6,2.2,6-1.9c0-.3-.1-.5-.3-.7-.2-.1-.3-.2-.6-.2h-4.7c-.4,0-.8,0-1.1,0-.3,0-.7-.1-1.1-.2l-2.2-.7.3-1,2,.7c.3.1.7.2,1.1.2.4,0,1,0,1.7,0,0-.3,0-.6-.2-.8-.1-.2-.3-.3-.5-.4l-5.8-2.1s0,0-.1,0c0,0,0,0-.1,0h-2.1s0,4.8,0,4.8ZM2.4,21v-8.2h6.1c0,0,.2,0,.3,0,0,0,.2,0,.3,0l5.8,2.1c.4.1.7.4.9.7.3.4.4.8.4,1.4h3c.6,0,1.1.2,1.4.6.3.4.5.9.5,1.4v.6l-7,2.2-7.6-2.2v1.3H2.4ZM3.4,20h2v-6.2h-2v6.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteerActivism);
export default __webpack_public_path__ + "static/media/volunteer_activism.0b7dc7ec46737743b2bed51a3a71a79e.svg";
export { ForwardRef as ReactComponent };